import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/referral-program',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/referral-program',
      name: 'referral-program',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/ReferralProgram.vue')
    }

  ]
};
export default app;
